module.exports = __webpack_public_path__ + "img/chinchilla_baby_and_mother.15f8e81f.jpeg";